import { SearchActions } from "~/types/actions.enum";
import { SEARCH_VIEW_MODE } from "~/types/search.types";

// ✅ Initial states
export const initialState: THelperState = {
    isModalOpen: false,
    isLoading: false,
    isError: false,
    isAppInitialized: false,
    timestamp: false,
    viewMode: SEARCH_VIEW_MODE.SELECTION,
    keyword: ""
};

// ✅ Types

// Action type defn
export type THelperAction =
    | { type: SearchActions.SET_IS_MODAL_OPEN; payload: boolean }
    | { type: SearchActions.SET_IS_LOADING; payload: boolean }
    | { type: SearchActions.SET_IS_ERROR; payload: boolean }
    | { type: SearchActions.SET_SEARCH_VIEW_MODE; payload: SEARCH_VIEW_MODE }
    | { type: SearchActions.SET_TOPIC_KEYWORD; payload: string }
    | { type: SearchActions.SET_IS_INITIALIZED; payload: boolean };

// State type defns
export type THelperState = {
    /** Flag indicating if the search pop-up modal is open or closed */
    isModalOpen: boolean;
    /** Flag indicating on-going fetching remote requests */
    isLoading: boolean;
    /** Flag for remote fetching errors */
    isError: boolean;
    /** Flag indicating a successful initial full meta data fetch */
    isAppInitialized: boolean;
    /** Timestamp of the latest Disclosures metadata fetch */
    timestamp: boolean;
    /** Results viewing modes of the search pop-up modal */
    viewMode: SEARCH_VIEW_MODE;
    /** Search text keyword within the pop-up modal */
    keyword: string;
};

// Store type
export type THelperMethods = "dispatch" | "reset";

export type THelperStore = THelperState & {
    /**
     * Sets the V3 Utils state using a reducer pattern.
     * @param {THelperAction} action - `THelperAction` action to apply.
     * @example
     * ```
     * const dispatch = useHelperStore((state) => state.dispatch)
     * dispatch({ type: SearchActions.SET_IS_MODAL_OPEN, payload: true })
     * ```
     */
    dispatch: (action: THelperAction) => void;
    /**
     * Resets the store to its initial state
     */
    reset: () => void;
};
